var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:({ width: _vm.contentWidth, zIndex: 2002, left: _vm.contentLeft })},[_c('img',{attrs:{"src":require("@assets/loading.gif"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }